
















import { Vue, Component } from 'vue-property-decorator';

    @Component
export default class SamclickDialog extends Vue {
  emitEventHandler(event: string) {
    this.$emit(event);
  }

  get defaultAttrs() {
    return {
      width: '65%',
      'destroy-on-close': true,
      'modal-append-to-body': false,
      'append-to-body': true,
      'close-on-click-modal': false,
      'close-on-press-escape': false,
    };
  }

  get overrideAttrs() {
    return Object.assign(this.defaultAttrs, this.$attrs);
  }

  mounted() {
  }
}
